import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import Showimage from "./modalshowimageslice"
import ReportCreate from "../chart/reportCreator";
// import Header from "./headerstatus";
// import Input from "../common/inputfunction";
// import RenderButton from "../common/button";
import {
  getuserondevice,
  getdevice,
  updatefacedata,
  updatesenddeleted,
} from "../../services/facescan";
import {getEvenLog,getEvenLogall,getLogPerHour} from "../../services/hrm"

 import BranchContext from "../context/branch";
// import ConfirmDelete from "../common/confirmDelete";
// import ConfirmSave from "../common/confirmSendFace";
 import RenderUser from "./renderuser";
import { toast } from "react-toastify";
 import ScrollToTop from "../common/ScrollToTop";
// import ProgressBar from "../common/progressbar";
// import Button  from "../common/button";


const UserOndevice = (props) => {
  //console.log(props);
  const [Id, setId] = useState(props.match.params.id);
  const { currentBranch } = useContext(BranchContext);
  const [name, setname] = useState("");
  const [search, setsearch] = useState("");
  const [status, setstatus] = useState(0);
  const [cardid, setCardId] = useState("");
  const [isShowimage, setisShowimage] = useState(false);
  const [data1, setData1] = useState({});
  const [facename, setfacename] = useState("");
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [pageSize, setPageSize] = useState(30);
  const [total, setTotal] = useState(0);
  const [userlist, setuserlist] = useState([]);
  
  const [lastupdate, setlastupdate] = useState(new Date());
  const [showonscroll, setshowonscroll] = useState(false);
  const [showprogress, setshowprogress] = useState(false);
  const [completed, setcompleted] = useState(50);
  const [onprocess, setonprocess] = useState(false);

  const [isOpen, setisOpen] = useState(false);
  const [isSaveOpen, setisSaveOpen] = useState(false);
  const [imageList, setimageList] = useState([]);
  const [datahour, setdatahour] = useState([]);
  // const [startDate, setStartDate] = useState(new Date());
  const currentdate = new Date();
  const [startDate, setStartDate] = useState(
    // new Date(moment(currentdate, "YYYY-MM-DD").format("YYYY-MM-DD"))
    new Date(currentdate.toDateString("yyyyMMdd HH:mm"))
  );
  const [endDate, setEndDate] = useState(new Date());


  // const checkScrollTop = () => {
  //   if (!showScroll && window.pageYOffset > 400){
  //     console.log('over 400')
  //     setShowScroll(true)
  //   } else if (showScroll && window.pageYOffset <= 400){
  //     setShowScroll(false)
  //     console.log('non 400')
  //   }
  // };

  // const scrollTop = () =>{
  //   window.scrollTo({top: 0, behavior: 'smooth'});
  // };

  // window.addEventListener('scroll', checkScrollTop)

  //console.log(Id);

  useEffect(() => {
    setuserlist([]);
  }, [
    startDate,endDate,
    pageSize,
  
  ]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   if (!Id) return;

  //   const loadData = async () => {
  //     const { data: result } = await getdevice(Id);
  //     if (result.status === "success") {
  //       setfacename(result.data.list[0].face_name);

  //       //  console.log(result.data.list[0].face_name)
  //     }
  //   };
  //   loadData();
  // }, [currentBranch, Id]);

  useEffect(() => {
 
    // if (!currentBranch) return;
    if (!pageSize || !pageNumber) return;
    setLoading(true);
    setError(false);
    // console.log(currentBranch,
    //   startDate,endDate,
    //   pageSize,
    //   pageNumber,
    //   lastupdate)
    const loadData = async () => {
      const { data: result } = await getEvenLog(
        moment(startDate, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm"),
        moment(endDate, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm"), 
        pageSize,
        pageNumber
      );
      if (result.status === "success") {
        setTotal(result.data.total);
        setshowprogress(false);
        setuserlist((prevData) => {
          return [...new Set([...prevData, ...result.data.list])];
        });
        setHasMore(result.data.list.length > pageSize - 1);
        setLoading(false);
      }
    };
    loadData();
  }, [
    
    startDate,endDate,
    pageSize,
    pageNumber,
    lastupdate,
   
  ]);

  useEffect(() => {
    if (!isShowimage) return;
    const loadData = async () => {
      const { data: result } = await getEvenLogall(
        moment(startDate, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm"),
        moment(endDate, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm"),      
      );
      if (result.status === "success") {
        setimageList(result.data.list);    
      }
    };
    loadData();
  }, [isShowimage]);

  useEffect(() => {

    const loadData = async () => {
      const { data: result } = await getLogPerHour(
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),      
      );
      if (result) {
        setdatahour(result)
      }
    };
    loadData();
  }, [startDate]);


  useEffect(() => {
    if (!datahour ) return;
    const chart = () => {
      let phour = [];
      let AmountA = [];

      for (const dataObj of datahour) {
        phour.push(dataObj.hour);
        AmountA.push(parseInt(dataObj.amount));
      }

      const data = {
        series: [
          { name: "จำนวน", data: AmountA },
          
        ],
        yLabels: phour,
        headers: "จำนวนต่อชั่วโมง",
        type: "bar",
        stacked: false,
      };
      setData1(data);
    };
    chart();
  }, [datahour]);



  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (node && node.offsetTop > 0) {
        setshowonscroll(true);
      }

      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );


  const handleOnClick = (cardid) => {
    setCardId(cardid);
    setisSaveOpen(true);

    // setonprocess(true);
  };


const handleChangeStartdates = (date) => {
 setStartDate(date)
 setPageNumber(1)
}
const handleChangeEnddates = (date) => {
  setEndDate(date)
  setPageNumber(1)
 }
 


  const handleTextchange = (event) => {
    setname(event.currentTarget.value);
  };
  const handleChange = (event) => {
    // setsearch(name)
    setstatus(event);
    setPageNumber(1);
    //    console.log('Click event',pageNumber);
  };
  const handleSearchClick = () => {
    setsearch(name);
    setPageNumber(1);
  };
  const onUpdate = () => {
    setlastupdate(new Date());
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setsearch(name);
    }
  };
  const scrollToTop = () => {
    setPageNumber(1);
    setshowonscroll(false);
  };
  const handelDelete = (event) => {
    setCardId(event);
    setisOpen(true);
    // setonprocess(true);
    // const doc = { face_id :Id, card_id : event}

    // SaveDelete(doc);
  };

  const confirmDelete = () => {
    setonprocess(true);
    setisOpen(false);
    const doc = { face_id: Id, card_id: cardid };

  
  };
  const handleonCancel = () => {
    setisOpen(false);
  };
  const handleonCancelSave = () => {
    setisSaveOpen(false);
  };
  const handelClose = () => {
    setisShowimage(false)
  }
  const onClickButtion = () => {
 setisShowimage(true)
  }

  const handleonClick = () => {

  }
  if (!currentBranch || 
    data1.series === undefined 

  ) {
    return <></>;
  }

  return (
    <>
    
    <Showimage
    isOpen={isShowimage} onCancel={handelClose} list={imageList}
    />

      <div className="row">

      <div className="col-auto">
            <div className="m-2">
              <i>
                จากวันที่ <span className="label label-default"></span>
              </i>

              <div className="mt-2" style={{ marginTop: 20, marginBottom: 20 }}>
                <DatePicker
                  todayButton="Today"
                  // dateFormat="dd/MM/yyyy"
                  timeFormat="HH:mm"
                  timeIntervals={30}
                  timeCaption="time"
                  dateFormat="dd/MM/yyyy HH:mm"
                  showTimeSelect
                  selected={startDate}
                  onChange={handleChangeStartdates}
                />
              </div>
            </div>
          </div>
          <div className="col-auto">
            <div className="m-2">
              <i>
                ถึงวันที่ <span className="label label-default"></span>
              </i>
              <div className="mt-2">
                <DatePicker
                  todayButton="Today"
                  timeFormat="HH:mm"
                  timeIntervals={30}
                  timeCaption="time"
                  dateFormat="dd/MM/yyyy HH:mm"
                  showTimeSelect
                  selected={endDate}
                  onChange={handleChangeEnddates}
                />
              </div>
            </div>
          </div>

        {/* <div className="col-lg-6  col-sm-6 col-xs-12">
          <div className="form-group">
            <Input
              name="devicename"
              value={name}
              label="รายชื่อ"
              placeholder="ระบุชื่อ/รหัสพนักงาน เพื่อค้นหา"
              onChange={handleTextchange}
              onClick={handleSearchClick}
              onKeyPress={handleKeyPress}
              search="ค้นหา"
            />
          </div>
        </div> */}
        {/* <div className="col-lg-6  col-sm-6 col-xs-12">
          <div className="form-group">
            <i>
              สถานะ <span className="label label-default"></span>
            </i>
            <div className="mt-2" style={{ marginTop: 20, marginBottom: 20 }}>
              <Header onChange={handleChange} />
            </div>
          </div>
        </div> */}
        {/* <div className="col-lg-6  col-sm-6 col-xs-12">
          <div className="col-auto mb-3 px-0">
            <ul className="btn-group p-0 m-0 ">
              <RenderButton label={facename} value="0" className={all} />
            </ul>
            <ul className="btn-group p-0 m-3 ">
              <Button 
              label="Export Excel" 
              className="btn btn-success"
              />
            </ul>
          </div>
            
        </div> */}
      </div>
<div className="row m-1">
<p className="text-success">
        แสดงข้อมูล {userlist ? userlist.length : 0} / {total} รายการ
      </p>
      {userlist && userlist.length > 0 && <button  className="btn btn-primary btn-sm m-1"
                            onClick={() =>
                              onClickButtion()
                            }
                            >
                              Show All

</button>}
</div>
<div className="col-auto">
<div className="mt-1">
          {
            <ReportCreate
              data={data1}
              type={"bar"}
              stacked={false}
              labelposition="top"
              palette={"palette6"}
              onclick={handleonClick}
            />
          }
        </div>
</div>

     

     
    
      {<ScrollToTop onClick={scrollToTop} />}
      <RenderUser
        list={userlist}
        handleOnClick={handleOnClick}
        handelDelete={handelDelete}
        error={error}
        lastBookElementRef={lastBookElementRef}
        onUpdate={onUpdate}
      />
    </>
  );
};

export default UserOndevice;
